<template>
		<div class="carousel-box bottom-padding overflow">
			<div class="title-box no-margin">
			<h1 class="title">View Cart</h1>
			</div>
			
			<div class="clearfix"></div>
			
			<div class="row">
        <article class="content span12">
            <div class="table-box">
                <table id="shopping-cart-table" class="shopping-cart-table table table-striped">
                <tbody>
                
                
                  <tr v-if="results.length<=0">
                      <td colspan="4">Your shopping cart is enpty!</td>
                  </tr>
                    <tr v-for="(result,index) in results" :key="index">
                <td class="td-images">
                  <router-link style="color:#ee7f82;font-size:14px;" :to="'/' + result.cpage_name + '/' + result.page_name">
                      <img :src="result.image_path" :alt="result.title"  :title="result.title" width="70" height="70">
                  </router-link>
                </td>
                <td class="td-name" >
                  <a href="javascript:void(0);"  v-on:click="removeFromCart(result)" class="product-remove pull-right">
                    <svg xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                        <g>
                        <path fill="#7f7f7f" d="M6,13c0.553,0,1-0.447,1-1V7c0-0.553-0.447-1-1-1S5,6.447,5,7v5C5,12.553,5.447,13,6,13z"></path>
                        <path fill="#7f7f7f" d="M10,13c0.553,0,1-0.447,1-1V7c0-0.553-0.447-1-1-1S9,6.447,9,7v5C9,12.553,9.447,13,10,13z"></path>
                        <path fill="#7f7f7f" d="M14,3h-1V1c0-0.552-0.447-1-1-1H4C3.448,0,3,0.448,3,1v2H2C1.447,3,1,3.447,1,4s0.447,1,1,1
                            c0,0.273,0,8.727,0,9c0,1.104,0.896,2,2,2h8c1.104,0,2-0.896,2-2c0-0.273,0-8.727,0-9c0.553,0,1-0.447,1-1S14.553,3,14,3z M5,2h6v1
                            H5V2z M12,14H4V5h8V14z"></path>
                        </g>
                    </svg>
                    </a><!-- .product-remove -->

                    <h2 class="product-name" style="margin-bottom:2px;">
                    <router-link style="color:#ee7f82;font-size:14px;" :to="'/' + result.cpage_name + '/' + result.page_name">{{result.title}} <br> <strong>Weight:</strong>{{result.weight}}</router-link>
                    </h2>
                    
                    <div  class="span2" >
                        <div  class="pull-right" v-if="result.size_list != ''">
                      <label>Size</label>
                      <div v-if="result.size_list != ''"   style="margin-bottom:-20px;" class="pull-right">
                      </div>
                      <select :id="'cboSize' + result.id" v-on:change="updateCart()" style="font-size:14px;-webkit-appearance:menulist;" v-model="result.size">
                        <option v-if="result.size_list == ''" value="" selected >none</option>
                        <option v-for="(sz,index) in result.size_list.split(',')" :key="index"  :value="sz">{{sz}}</option>
                      </select>
                      </div>
                    </div>
                    <div  class="span4">
                      <div class=" pull-right"> 
                        <label>Pcs</label>
                        <div  style="width:45%;" class="pull-left">
                          <input readonly class="input-block-level" style="text-align:center;font-size:16px;width:95%;-webkit-box-shadow:0 0px #fff, inset 0 0px 0px rgba(0,0,0,.15);" maxlength="3" min="1" step="1" onblur="txtqty_onblur(this);" onkeypress="return intDigits(event);" type="number" v-model="result.qty" value="1">
                          </div>
                          
                        <div  style="width:55%" class="pull-right">
                          <button type="button" class="btn btn-default" v-on:click="numUp(result)" style="margin-right:5px"><i class="fa fa-plus"></i></button>
                          <button type="button" class="btn btn-default"  v-on:click="numDown(result)" ><i class="fa fa-minus"></i></button>
                        </div>
                      </div>
                    </div>

                
                    
                </td>
                    </tr>
                                    </tbody>
                </table><!-- .shopping-cart-table -->
            </div>
            <table class="shopping-cart-table shopping-cart-table-button table table-bordered table-striped">
                <tbody><tr>
                <td class="action">
                  <router-link to="/"><i class="fa fa-angle-left"></i> Continue Shopping</router-link>
                    <a v-on:click="updateCart()" class="update"><i class="fa fa-rotate-right"></i> Update Shopping Cart</a>
                </td>
                </tr>
            </tbody></table>
            <div id="car-bottom" class="row">
              <div class="span4 pull-right">
                  <div class="car-bottom-box bg total">
                    <table>
                <tr>
                  <td>Pcs:</td>
                  <td><span class="price">{{CountTotalPcs()}}</span></td>
                </tr>
                <tr class="tr-total">
                  <td>Gross Weight:</td>
                  <td><span class="price">{{CountTotalWeight()}}</span></td>
                </tr>
                    </table>
                    <div>
                <router-link to="/checkout" v-if="Session.is_login" class="btn btn-large checkout pull-right">Proceed to Checkout</router-link>
                   <router-link to="/login/?f=checkout" v-if="!Session.is_login" class="btn btn-large checkout pull-right">Proceed to Checkout</router-link>
                    </div>
                    <br><br><br>
                  </div>
                  <div class="clesrfix"></div>
                </div>
                   
            </div>


            

        </article>
			</div>
		</div>
</template>
<script>
//import axios from 'axios'
import Vue from 'vue'
import $ from 'jquery'
import Common from '@/common.js'
import OnLoad from 'vue-onload'
import Vue2TouchEvents from 'vue2-touch-events'
import {mapGetters, mapActions} from "vuex";

Vue.use(OnLoad);
Vue.use(Vue2TouchEvents)



export default {
	name:'CartList',
   data: function(){
    return {
    results: []
    }
  },  props: {
    msg: String
  },mounted: function() {

    //alert(this.$route.params.categoryId);
    this.loadOnMount();

    //axios.get("http://localhost/api/categories.php")
    //.then(response => {this.results = response.data})
    
  },created(){
    this.getSession;
    this.getCart;
    this.removeFromCart;
},
  computed:mapGetters(["Cart","CartCount","Session"]),
    watch:{
    Cart(newValue) {this.get_response(newValue)  },
    CartCount(newValue) { this.results.cart_count = newValue  },
    Session() { },
    $route() {
      this.get_response(this.getCart());
      
    }
  },methods:{
          ...mapActions(["removeFromCart","getCart","getSession"]),
          loadOnMount: function()
          {
              this.getSession();
              this.get_response(this.getCart());
              //Common.callServerFunction("Items/ItemController::GetCategoryItems",this.get_response,{'category':this.$route.params.categoryId},"Item");
          },
          updateCart()
          {
              var qtys = this.results.map(function (a) { return a.qty; }).join();
              var sizes = this.results.map(function (a) { return a.size; }).join();
              
              Common.callServerFunction("Cart/CartController::UpdateCart",this.get_update_cart_response,{'qty':qtys,'sizes':sizes},"Cart");
          },numUp(item)
          {
            var val = item.qty;
            if(val != "")
            {
              item.qty = parseInt(item.qty)+1;
            }else
            {
              item.qty = 1;
            }
            this.updateCart();
          },
          numDown(item)
          {
            var val = parseInt(item.qty);
            if(val != "")
            {
              if(parseInt(val) > 1)
              { 
                item.qty = parseInt(item.qty) - 1
              }else
              {
                item.qty = 1;
              }
            }else
            {
              item.qty = 1;
            }
            this.updateCart();
          },
          touchHandler (event) {
            
            var purl =  $(event.target).attr('href');
            if(purl != undefined)
            {
              this.$router.push(purl);
            }else
            {
              purl = $(event.target).parent().attr('href');
              this.$router.push(purl);
            }

            //console.log($(event.target).parent())  // May be left / right / top / bottom
        },
        get_update_cart_response:function()
        {
          this.getCart();
        },
        CountTotalWeight:function()
        {
          var total_weight = 0;
          if(this.results.length > 0){
                this.results.forEach((item) => {
                   total_weight = parseFloat(total_weight) + parseFloat(item.weight);
                });
          }
          return total_weight;
        },CountTotalPcs:function()
        {
          var total_pcs = 0;
          
          if(this.results.length > 0){
                this.results.forEach((item) => {
                   total_pcs = parseFloat(total_pcs) + parseFloat(item.qty);
                });
          }
          return total_pcs;
        },
          get_response:function(response)
          {	
            //var rdata = JSON.parse(response);
            var rdata = response;
            this.results = response;
            
                var jimage = [];
                

                if(rdata.length > 0){
                  Common.startAjaxLoader();
                rdata.forEach((item,index) => {
                    console.log(item.image_path + " - " + index);
                    jimage.push(item.image_path)
                });
                
                this.preload = false
                this.$nextTick(function() {
                  this.$images.preload(jimage,
                  (completed) => {
                    //(completed, progress) => {
                      // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
                      //console.log(Math.round(progress * 100))
                      // completed = true when all images are loaded
                      if (completed) {
                        this.preload = true
                        //console.log(completed);
                        eval('loadFunctions();');
                        Common.stopAjaxLoader();
                      }
                    }
                  )
                })

                //$(".item").eq(0).addClass('item active');


                          //$.get('./js/main.js', function(data) {
                        //eval(data);
                        //eval('setTimeout(loadFunctions(),1000);');

                //});
              }    
                
         }   
   }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
